// Top-level navigation tabs for KCC: Tenants / Access / Releases / Audit.
// Cost / Branding / Governance live as sub-tabs inside the per-tenant detail
// screen.
export const adminTabs = [
{ key: "tenants", label: "Tenants", path: "/tenants" },
{ key: "access", label: "Access", path: "/access" },
{ key: "releases", label: "Releases", path: "/releases" },
{ key: "audit", label: "Audit", path: "/audit" },
];